import queryString from 'querystring';
import { handleHttpResponse } from '#/shared/utils/http';

const DEFAULT_REVERSE_GEOCODER_QUERY = {
  layers: 'address',
};
const EMPTY_FEATURE_SET = { features: [] };

export const fetchReverseGeocoderResults = async (config, params = {}) =>
  fetch(
    `${config.baseUrl}/${config.paths.reverse}?${queryString.encode({
      ...DEFAULT_REVERSE_GEOCODER_QUERY,
      ...params,
    })}`
  )
    .then(handleHttpResponse)
    /* 
      If we get an error response from the geocoder, we should just pass
      through an empty feature set this way we can fall back on default behavior 
     */
    .catch(() => EMPTY_FEATURE_SET);

export const fetchLocationLabel = async (getState, { lat, lon }) => {
  const { geocoderConfig: api } = getState().shared.location;
  const response = await fetchReverseGeocoderResults(api, {
    'point.lat': lat,
    'point.lon': lon,
  });
  if (!response.features || !response.features.length) {
    return { label: '', region: '' };
  }
  const sortedFeatures = [...response.features];
  sortedFeatures.sort((a, b) => a.properties.distance - b.properties.distance);
  const { label, region } = sortedFeatures[0].properties;
  return { label, region };
};
